function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** @ignore */ /** */
import * as $array from "./Array";
import * as $utils from "./Utils";
/**
 * @ignore
 */
var Native = /*#__PURE__*/function () {
  function Native() {
    var _this = this;
    _classCallCheck(this, Native);
    Object.defineProperty(this, "_observer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_targets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    this._observer = new ResizeObserver(function (entries) {
      $array.each(entries, function (entry) {
        $array.each(_this._targets, function (x) {
          if (x.target === entry.target) {
            x.callback();
          }
        });
      });
    });
  }
  _createClass(Native, [{
    key: "addTarget",
    value: function addTarget(target, callback) {
      this._observer.observe(target, {
        box: "border-box"
      });
      this._targets.push({
        target: target,
        callback: callback
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(target) {
      this._observer.unobserve(target);
      $array.keepIf(this._targets, function (x) {
        return x.target !== target;
      });
    }
  }]);
  return Native;
}();
/**
 * @ignore
 */
var Raf = /*#__PURE__*/function () {
  function Raf() {
    _classCallCheck(this, Raf);
    Object.defineProperty(this, "_timer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "_targets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
  _createClass(Raf, [{
    key: "addTarget",
    value: function addTarget(target, callback) {
      var _this2 = this;
      if (this._timer === null) {
        var lastTime = null;
        var loop = function loop() {
          var currentTime = Date.now();
          if (lastTime === null || currentTime > lastTime + Raf.delay) {
            lastTime = currentTime;
            $array.each(_this2._targets, function (x) {
              var newSize = x.target.getBoundingClientRect();
              if (newSize.width !== x.size.width || newSize.height !== x.size.height) {
                x.size = newSize;
                x.callback();
              }
            });
          }
          if (_this2._targets.length === 0) {
            _this2._timer = null;
          } else {
            _this2._timer = requestAnimationFrame(loop);
          }
        };
        this._timer = requestAnimationFrame(loop);
      }
      // We start off with fake bounds so that sensor always kicks in
      var size = {
        width: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        x: 0,
        y: 0
      };
      this._targets.push({
        target: target,
        callback: callback,
        size: size
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(target) {
      $array.keepIf(this._targets, function (x) {
        return x.target !== target;
      });
      if (this._targets.length === 0) {
        if (this._timer !== null) {
          cancelAnimationFrame(this._timer);
          this._timer = null;
        }
      }
    }
  }]);
  return Raf;
}();
Object.defineProperty(Raf, "delay", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 200
});
/**
 * @ignore
 */
var observer = null;
/**
 * @ignore
 */
function makeSensor() {
  if (observer === null) {
    if (typeof ResizeObserver !== "undefined") {
      observer = new Native();
    } else {
      observer = new Raf();
    }
  }
  return observer;
}
/**
 * @ignore
 */
export var ResizeSensor = /*#__PURE__*/function () {
  function ResizeSensor(element, callback) {
    _classCallCheck(this, ResizeSensor);
    Object.defineProperty(this, "_sensor", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_element", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_listener", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    this._sensor = makeSensor();
    this._element = element;
    // This is needed because we need to know when the window is zoomed
    this._listener = $utils.onZoom(callback);
    this._sensor.addTarget(element, callback);
  }
  _createClass(ResizeSensor, [{
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        this._sensor.removeTarget(this._element);
        this._listener.dispose();
      }
    }
  }, {
    key: "sensor",
    get: function get() {
      return this._sensor;
    }
  }]);
  return ResizeSensor;
}();